<template>
<div class="flex-container">
    <md-layout md-vertical-align="center" v-if="ready">
        <md-layout md-flex="30" md-flex-offset="35" md-align="center">
            <h1>
                <span class="sr-only">Cuelist</span>
                <img :src="require('../assets/img/cuelistBLACK.png')" alt="LOGO"/>
            </h1>
        </md-layout>
        <md-layout md-flex="100" md-align="center" >
            <h1 class="md-headline">Collaborate on <strong>{{project.title}}</strong></h1>
        </md-layout>
        <md-layout md-flex="100" md-align="center" v-if="validCollab">
            <md-layout md-flex="100" md-align="center">
                <md-button class="md-raised md-primary" @click="accept"><md-icon>person</md-icon>&nbsp;Accept Invite</md-button>
            </md-layout>    
        </md-layout>
        <md-layout md-flex="100" md-align="center" v-if="!validCollab">
            <h2 class="md-title">You have not been invited to this project.</h2>
        </md-layout>
    </md-layout>
</div>
</template>

<script>
import firebase from 'firebase/app';
import { db } from '@/main';
import { mapGetters } from 'vuex';
import CoreFooter from '@/components/core/footer';

const AcceptInviteView = {
    name: 'AcceptInviteView',
    props: ['id'],
    data: function() {
        return {
            ready: false,
            validCollab: null
        };
    },
    watch: {
        project: function() {
            this.checkProjectStatus();
        },
        user: function() {
            this.checkProjectStatus();
        },
        pendingCollaborators: function() {
            this.checkProjectStatus();
        }
    },
    methods: {
        setValidCollab() {
            const index = this.pendingCollaborators.findIndex((pc) => {
                return pc.email === this.user.email;
            });

            if (index > -1) {
                this.validCollab = this.pendingCollaborators[index];
            }
        },
        async accept() {
            try {
                await this.$store.dispatch('addCollaborator', {
                    project: this.project,
                    uid: this.user.uid,
                    pendingCollaborator: this.validCollab
                });
            } catch (err) {
                console.error('Accept invite failed:', err);
            }
            this.$router.replace(`/project/${this.id}`);
        },
        checkProjectStatus() {
            if (this.project || (this.user && this.user.uid)) {
                this.ready = true;

                const index = this.pendingCollaborators.findIndex((pc) => {
                    return (pc.email || '').toLowerCase() === (this.user.email || '').toLowerCase();
                });

                if (index > -1) {
                    this.validCollab = this.pendingCollaborators[index];
                } else {
                    this.validCollab = null;
                }
            }
        }
    },
    components: {
        'core-footer': CoreFooter
    },
    computed: {
        ...mapGetters([
            'project',
            'user',
            'layers',
            'pendingCollaborators'
        ])
    },
    beforeRouteEnter: function(to, from, next) {
        next((vm) => {
            vm.$store.dispatch('setActiveProject', {
                ref: db.collection('projects').doc(vm.id),
                callback: () => {}
            });
            vm.$store.dispatch('setActiveUser', {
                ref: db.collection('users').doc(firebase.auth().currentUser.uid),
                callback: () => {}
            });
            vm.$store.dispatch('setInvitationsRef', {
                ref: db.collection('invitations'),
                callback: () => {}
            });
        });
    }
};
export default AcceptInviteView;
</script>

<style>
.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
}
</style>


// WEBPACK FOOTER //
// accept-invite.vue?06ef2ac3